import { LocalizationTexts, OptimusTextKey, TranslationOptions } from '@optimus-web/localization';
import { LocalizedText } from './modern/text/LocalizedText';
import { FrameworkTextKey as TextKey } from './FrameworkTextKey';

export const defaultLocalizationTexts: LocalizationTexts = {
    [OptimusTextKey.ChartEmptyDefaultMessage]: <LocalizedText textKey={TextKey.ChartEmptyDefaultMessage} />,
    [OptimusTextKey.ChartErrorDefaultMessage]: <LocalizedText textKey={TextKey.ChartErrorDefaultMessage} />,
    [OptimusTextKey.DialogedDatePickerCancel]: <LocalizedText textKey={TextKey.Cancel} />,
    [OptimusTextKey.NoResultsForSearch]: <LocalizedText textKey={TextKey.NoResultsForSearch} />,
    [OptimusTextKey.TableClearFilters]: <LocalizedText textKey={TextKey.ClearFilters} />,
    [OptimusTextKey.TableEmptyStatePrimary]: <LocalizedText textKey={TextKey.NoDataAvailable} />,
    [OptimusTextKey.TableFilterBySearch]: <LocalizedText textKey={TextKey.FilterBySearch} />,
    [OptimusTextKey.TableFilterContains]: <LocalizedText textKey={TextKey.Contains} />,
    [OptimusTextKey.TableFilterGreaterThan]: <LocalizedText textKey={TextKey.GreaterThan} />,
    [OptimusTextKey.TableHeaderSearch]: <LocalizedText textKey={TextKey.Search} />,
    [OptimusTextKey.TablePaginationItemsCount]: ({ items }: TranslationOptions = {}) => (
        <LocalizedText textKey={items === 1 ? TextKey.ItemSingular : TextKey.ItemPlural} substitutes={{ items }} />
    ),
    [OptimusTextKey.TablePaginationSizeItemsCount]: ({ items }: TranslationOptions = {}) => (
        <LocalizedText textKey={TextKey.PaginationItems} substitutes={{ items }} />
    ),
    [OptimusTextKey.TablePaginationShow]: <LocalizedText textKey={TextKey.Show} />,
    [OptimusTextKey.TableSortAscending]: <LocalizedText textKey={TextKey.SortAscending} />,
    [OptimusTextKey.TableSortDescending]: <LocalizedText textKey={TextKey.SortDescending} />,
    [OptimusTextKey.SelectAll]: <LocalizedText textKey={TextKey.SelectAll} />,
    [OptimusTextKey.DeselectAll]: <LocalizedText textKey={TextKey.DeselectAll} />,
    [OptimusTextKey.Optional]: <LocalizedText textKey={TextKey.Optional} />,
    [OptimusTextKey.Of]: <LocalizedText textKey={TextKey.Of} />,
    [OptimusTextKey.ChooseFile]: <LocalizedText textKey={TextKey.ChooseFile} />,
    [OptimusTextKey.DropzoneFileLimitOverReachedError]: (
        <LocalizedText textKey={TextKey.DropzoneFileLimitOverReachedError} />
    ),
    [OptimusTextKey.DropzoneFileLimitReached]: <LocalizedText textKey={TextKey.DropzoneFileLimitReached} />,
    [OptimusTextKey.Or]: <LocalizedText textKey={TextKey.Or} />,
    [OptimusTextKey.ClearSelection]: <LocalizedText textKey={TextKey.ClearSelection} />,
    [OptimusTextKey.SelectEmptyMessage]: <LocalizedText textKey={TextKey.NoResultsForSearch} />,
    [OptimusTextKey.Ok]: <LocalizedText textKey={TextKey.Ok} />,
    [OptimusTextKey.Cancel]: <LocalizedText textKey={TextKey.Cancel} />,
    [OptimusTextKey.Today]: <LocalizedText textKey={TextKey.Today} />,
    [OptimusTextKey.Yesterday]: <LocalizedText textKey={TextKey.Yesterday} />,
    [OptimusTextKey.Tomorrow]: <LocalizedText textKey={TextKey.Tomorrow} />,
    [OptimusTextKey.ThisWeek]: <LocalizedText textKey={TextKey.ThisWeek} />,
    [OptimusTextKey.LastWeek]: <LocalizedText textKey={TextKey.LastWeek} />,
    [OptimusTextKey.NextWeek]: <LocalizedText textKey={TextKey.NextWeek} />,
    [OptimusTextKey.ThisMonth]: <LocalizedText textKey={TextKey.ThisMonth} />,
    [OptimusTextKey.LastMonth]: <LocalizedText textKey={TextKey.LastMonth} />,
    [OptimusTextKey.NextMonth]: <LocalizedText textKey={TextKey.NextMonth} />,
    [OptimusTextKey.ThisQuarter]: <LocalizedText textKey={TextKey.ThisQuarter} />,
    [OptimusTextKey.LastQuarter]: <LocalizedText textKey={TextKey.LastQuarter} />,
    [OptimusTextKey.NextQuarter]: <LocalizedText textKey={TextKey.NextQuarter} />,
    [OptimusTextKey.ThisYear]: <LocalizedText textKey={TextKey.ThisYear} />,
    [OptimusTextKey.LastYear]: <LocalizedText textKey={TextKey.LastYear} />,
    [OptimusTextKey.NextYear]: <LocalizedText textKey={TextKey.NextYear} />,
    [OptimusTextKey.Custom]: <LocalizedText textKey={TextKey.GeneralCustom} />,
};
